import { images } from '../constants';

const process = [
  {
    id: 1,
    image: images.step1,
    title: 'Schedule Services',
    content: 'Initiate the process by scheduling laundry and dry cleaning services. Choose a time for pickup and delivery.',
  },
  {
    id: 2,
    image: images.step2,
    title: 'Fabric Inspection',
    content: 'Our experts conduct a thorough inspection of the fabrics to determine the appropriate cleaning methods.',
  },
  {
    id: 3,
    image: images.step3,
    title: 'Specialized Cleaning',
    content: 'We employ specialized cleaning techniques for different fabrics and address specific stains or requirements.',
  },
  {
    id: 4,
    image: images.step4,
    title: 'Quality Assurance',
    content: 'Each item undergoes a rigorous quality check to ensure that it meets our standards of cleanliness.',
  },
  {
    id: 5,
    image: images.step5,
    title: 'Delivery',
    content: 'Once the cleaning process is complete and quality is assured, we deliver your freshly cleaned and pressed items.',
  },
  {
    id: 6,
    image: images.step6,
    title: 'Customer Satisfaction',
    content: 'We value your feedback! After the delivery, let us know about your experience. Your satisfaction is our priority.',
  },
];

export default process;